import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Book, BookOpen } from "@phosphor-icons/react";
import duasSections from "../../data/duasSections.json";
import PageTitle from "../../components/ui/PageTitle";
import { slugify } from "./utils";

type DuaItem = {
  title: string;
  header?: string;
  text?: string;
  text2?: string;
};
type DuaParent = { title: string; icon?: string; duas?: DuaItem[] };
type Section = { title: string; items: DuaParent[] };

export default function MafatihPage() {
  const navigate = useNavigate();

  return (
    <Container>
      <PageTitle
        icon={<Book size={28} color="var(--primary)" weight="bold" />}
        center
      >
        مفاتيح الجنان
      </PageTitle>
      <Subtitle>فهرس الأدعية والزيارات من مفاتيح الجنان</Subtitle>

      {(duasSections as Section[]).map((section, si) => (
        <SectionCard key={si}>
          <SectionTitle>{section.title}</SectionTitle>
          <Grid dir="rtl">
            {section.items.map((it, i) => (
              <Tile
                key={i}
                onClick={() =>
                  it.duas && navigate(`/mafatih/list/${slugify(it.title)}`)
                }
                title={it.title}
              >
                <IconCircle>
                  <BookOpen size={20} color="var(--primary)" weight="duotone" />
                </IconCircle>
                <TileText>{it.title}</TileText>
              </Tile>
            ))}
          </Grid>
        </SectionCard>
      ))}
    </Container>
  );
}

/* styles */
const Container = styled.div`
  padding: 24px 16px;
  max-width: 960px;
  margin: 0 auto;
`;
const Subtitle = styled.p`
  text-align: center;
  color: var(--textSecondary);
  font-size: 0.95rem;
  margin: 6px 0 16px;
`;
const SectionCard = styled.div`
  background: var(--surface);
  border-radius: 16px;
  box-shadow: var(--shadow);
  padding: 14px;
  margin-bottom: 16px;
`;
const SectionTitle = styled.h3`
  margin: 0 0 12px;
  text-align: center;
  font-weight: 300;
  color: var(--primary);
  font-size: 2rem;
  font-family: lateef;
`;
const Grid = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(2, 1fr);
  @media (min-width: 680px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (min-width: 960px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;
const Tile = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 14px 10px;
  border: 1px solid var(--border);
  background: var(--surface);
  color: var(--text);
  border-radius: 14px;
  cursor: pointer;
  box-shadow: var(--shadow);
  transition: transform 0.12s ease, box-shadow 0.12s ease, background 0.12s ease;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 18px rgba(0, 0, 0, 0.12);
  }
`;
const IconCircle = styled.div`
  width: 38px;
  height: 38px;
  border-radius: 19px;
  display: grid;
  place-items: center;
  background: var(--surface-2, rgba(0, 0, 0, 0.05));
`;
const TileText = styled.span`
  flex: 1;
  text-align: center;
  font-size: 1rem;
  font-weight: 400;
  color: var(--text);
  font-family: rubik;
`;
